import approvalConfiguration from "../../cbt/api/approvalConfiguration";
import Logger from "../../services/Logger";
import { resolvePolicyResolvedId } from "./resolvePolicyResolvedId";

export async function handleCbtManagerApproval(
  cbt,
  policyResolvedId,
  cbtConnectionData,
  isHotel = false
) {
  const initialResult = { travellers: [], shouldDisplayGuests: false };

  const isCbtConnectionEnabled =
    cbtConnectionData &&
    cbtConnectionData.cbtApiUrl &&
    cbtConnectionData.customerUsername &&
    cbtConnectionData.cbtToken;

  if (!isCbtConnectionEnabled) {
    return initialResult;
  }

  const resolvedPolicyResolvedId = resolvePolicyResolvedId({
    isHotel,
    queryPolicyResolvedId: policyResolvedId,
    cbtPolicyResolvedId: cbt.policyResolvedId,
    cbtPassengersFormPolicyResolvedId: cbt?.passengersForm?.policyResolvedId,
  });

  if (!resolvedPolicyResolvedId) {
    Logger.error("Manager Approval missing policy resolved ID", {
      tags: {
        area: "cbt",
        flow: "manager-approval",
      },
      extra: {
        isHotel,
        hasCbtConnectionData: !!cbtConnectionData,
        hasCbtToken: !!cbtConnectionData?.cbtToken,
        hasCbtApiUrl: !!cbtConnectionData?.cbtApiUrl,
        hasCustomerUsername: !!cbtConnectionData?.customerUsername,
        hasQueryPolicyResolvedId: Array.isArray(policyResolvedId)
          ? policyResolvedId.length > 0
          : !!policyResolvedId,
        hasCbtPolicyResolvedId: !!cbt?.policyResolvedId,
        hasCbtPassengersFormPolicyResolvedId: !!cbt?.passengersForm
          ?.policyResolvedId,
        travellersCount: Array.isArray(cbt?.passengersForm?.travellers)
          ? cbt.passengersForm.travellers.length
          : 0,
        hasUsersCache: !!cbt?.usersCache,
      },
    });
    return initialResult;
  }

  const travellers =
    cbt.passengersForm?.travellers && cbt.usersCache
      ? cbt.passengersForm.travellers.map((id) => {
          const { Id, FirstName, LastName, Email } = cbt.usersCache[id];
          return { Id, FirstName, LastName, Email };
        })
      : [];

  const config = await approvalConfiguration({
    cbtConnectionData,
    policyResolveId: resolvedPolicyResolvedId,
  });

  const managedTravellers = config.reduce((acc, curr) => {
    if (curr.Type === "Traveller" && curr.ShouldDisplaySelector) {
      return {
        travellers: [
          ...acc.travellers,
          {
            TravellerId: curr.TravellerId,
            Email: travellers.find(({ Id }) => Id === curr.TravellerId).Email,
          },
        ],
        shouldDisplayGuests: acc.shouldDisplayGuests,
      };
    }
    if (curr.Type === "Guest" && curr.ShouldDisplaySelector) {
      return {
        travellers: acc.travellers,
        shouldDisplayGuests: true,
      };
    }
    return acc;
  }, initialResult);

  return managedTravellers;
}
